import $ from 'jquery';
$("a.edit-bank-details-uk").click(function(){
    $('.cwm-banking-details .view-bankdetails').hide();
    $('a.edit-bank-details-uk').hide();
    $(".cwm-editviewdeatails-form").show();
    $("#bankDetails_editForm").show();
    
    $('html,body').animate({
        scrollTop: $(".cwm-editviewdeatails-form").offset().top - 100},
        '2000');
  });
  $("a.edit-bank-details-int").click(function(){
    $('.cwm-banking-details .view-bankdetails').hide();
    $('a.edit-bank-details-int').hide();
    $(".cwm-editviewdeatails-form").show();
    $("#cwm-internationalbank-form").show();
    
    $('html,body').animate({
        scrollTop: $(".cwm-editviewdeatails-form").offset().top - 100},
        '2000');
  });
  $("a.uk-acc-link").click(function(){
    $('.cwm-banking-details .view-bankdetails').hide();
    $(".cwm-editviewdeatails-form").show();
    $("#bankDetails_editForm").show();
    $('html,body').animate({
        scrollTop: $(".cwm-editviewdeatails-form").offset().top - 100},
        '2000');
  } );
  
  $("a.others-acc-link").click(function(){
    $('.cwm-banking-details .view-bankdetails').hide();
    $(".cwm-editviewdeatails-form").show();
    $("#cwm-internationalbank-form").show();
    $('html,body').animate({
        scrollTop: $(".cwm-editviewdeatails-form").offset().top - 100},
        '2000');
  } );
  
  //masking for account  no. view
  function accountMask() {

    var maskNumber = $("#cwm-account-no").text();

    var string = String(maskNumber);

    var sliced = string.slice(-4);  

    var mask = String(sliced).padStart(string.length, "*")

    return mask;

 }
 
 var maskedNumber = accountMask();
 $('#cwm-account-no').empty().append(maskedNumber);

 function ibanMask() {

    var maskNumber1 = $("#cwm-iban-no").text();

    var string1 = String(maskNumber1);

    var sliced1 = string1.slice(-4);  

    var mask1 = String(sliced1).padStart(string1.length, "*")

    return mask1;

 }

 
 var maskedNumber1 = ibanMask();
 $('#cwm-iban-no').empty().append(maskedNumber1);

//  swiftMask
 function swiftMask() {

    var maskNumber2 = $("#cwm-swiftbic-no").text();

    var string2 = String(maskNumber2);

    var sliced2 = string2.slice(-2);  

    var mask2 = String(sliced2).padStart(string2.length, "*")

    return mask2;

 }

 
 var maskedNumber2 = swiftMask();
 $('#cwm-swiftbic-no').empty().append(maskedNumber2);

//Masking for short code view

 var mainStr = $("#cwm-short-code").text(),

        vis = mainStr.slice(-2),

        countNum = '';    

        for(var i = (mainStr.length)-4; i>0; i--){

            countNum += '*';

        }

        var xsol = countNum+vis;

            // alert(xsol);

        function separateStr(str, divider,  n) {

            var ret=[];    

            for(let i=0; i<str.length; i=i+n) {

                ret.push(str.substr(i, n))

            };    

                return ret.join(divider);

        };
        var solution = separateStr(xsol, '-',  2);
        
    $("#cwm-short-code").text(solution);




// WEBPACK FOOTER //
// ./components/cwm-editmybank-details/scripts/bank-details-view.js